export { revalidateCommunity } from 'next-flight-server-reference-proxy-loader?id=40c8f3e540fe54fc4c00c077b16d0151add4d25d6c&name=revalidateCommunity!'